import { connect } from 'react-redux'
import Header from '../../components/layouts/header'
import { push } from 'react-router-redux/actions'
import {
  handleLogout,
  checkActive,
  loadInfoPages,
} from '../../actions'

import {
  LOGOUT_EP,
  CHECK_STATUS_CREATOR_EP,
  INFO_EP,
} from '../../constant'

const mapStateToProps = ({
  mediaQuery: {
    screen,
  },
  session: {
    authenticated: auth,
    user: sessionInfo,
  },
  router: {
    location: {
      pathname,
    },
  },
  info: {
    active: activeStatus,
  },
  info,
}) => {
  return {
    auth,
    sessionInfo,
    screen,
    activeStatus,
    info,
    pathname,
  }
}

const mapDispatchToProps = dispatch => ({
  onLoadLogout: () => {
    dispatch(handleLogout(LOGOUT_EP))
  },
  onLoadCheckActive () {
    dispatch(checkActive(CHECK_STATUS_CREATOR_EP))
  },
  onLoadInfo () {
    dispatch(loadInfoPages(INFO_EP))
  },
  onChangeRoute (pathName) {
    dispatch(push(pathName))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(Header)



// WEBPACK FOOTER //
// ./src/containers/layouts/Header.js